﻿export function videoBanner() {

    const init = function () {

        var elements = [].slice.call(document.querySelectorAll('.video-banner video'));

        if (!elements || elements.length === 0)
            return;

        if (!("IntersectionObserver" in window))
            return;

        var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        elements.forEach(function (element) {
            lazyVideoObserver.observe(element);
        });
    };

    init();
}